<template>
    <div>
      <div class="baseInfo">

      </div>
    </div>
</template>
<script>
  import topBar from '../topBar'
    export default{
        data(){
            return {}
        },
        computed:{
        },
        props: {
          baseInfos:{
              type: Object
          }
        },
        methods: {},
        components:{
          topBar
        },
      mounted(){
            console.log(1)
      }
    }
</script>
<style scoped>
.baseInfo{
  /*width: 464px;
  box-sizing: border-box;
  border: 1px solid #ababab;*/
}
</style>



// WEBPACK FOOTER //
// baseInfo.vue?6996ac7e